import React, { useState } from "react";
import PositionCard from "./PositionCard";
import DeleteConfirmModal from "./DeleteConfirmModal";
import {
  fetchProjectPositions,
  deletePosition,
} from "../../redux/slices/projectEditSlice";
import { useDispatch } from "react-redux";

const OpenPositions = ({
  positions = [],
  setIsOpen,
  setModalType,
  projectId,
}) => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [error, setError] = useState(null);

  const formattedPositions = positions
    .filter((position) => position && position._id)
    .map((position) => ({
      _id: position._id,
      title:
        position.type && position.positionName
          ? `${position.type} ${
              typeof position.positionName === "object"
                ? position.positionName.name
                : position.positionName
            }`
          : "Pozisyon Adı Belirtilmemiş",
      techs: Array.isArray(position.expectations)
        ? position.expectations.map((exp, index) => ({
            _id: `tech-${position._id}-${index}`,
            name:
              typeof exp === "object" ? exp.name : exp || "Belirsiz Teknoloji",
          }))
        : [],
    }));
  console.log("OpenPositions positions:", positions);
  console.log("Formatlanmış Pozisyonlar:", formattedPositions);

  const handleDeleteClick = (formattedPosition) => {
    // Orijinal position objesini bul
    const originalPosition = positions.find(
      (p) => p._id === formattedPosition._id
    );
    console.log("Original position to delete:", originalPosition);
    setSelectedPosition(originalPosition);
    setIsModalOpen(true);
  };

  const confirmDelete = async () => {
    if (!selectedPosition) return;

    try {
      console.log("Deleting position with ID:", selectedPosition._id);
      await dispatch(deletePosition(selectedPosition._id)).unwrap();
      dispatch(fetchProjectPositions(projectId));
      setSelectedPosition(null);
      setIsModalOpen(false);
    } catch (error) {
      setError(error);
    }
  };

  return (
    <div className="detay-container">
      <div className="flex justify-between p-[6px] px-[8px] items-center">
        <h2 className="text-dark font-medium text-xl">Açık Pozisyonlar</h2>
        <button
          onClick={() => {
            setModalType("Yeni Pozisyon Ekle");
            setIsOpen(true);
          }}
          className="btn-transparent text-dark text-xs "
        >
          Yeni Pozisyon Ekle +
        </button>
      </div>

      <div className="pt-4">
        {formattedPositions.length > 0 ? (
          formattedPositions.map((position, index) => (
            <div key={position._id}>
              <PositionCard
                position={position}
                removePosition={handleDeleteClick}
              />
              {/* Son elemandan sonra çizgi ekleme */}
              {index !== formattedPositions.length - 1 && (
                <hr className="border-gray-300 my-4" />
              )}
            </div>
          ))
        ) : (
          <p className="text-dark text-sm">Açık pozisyon bulunamadı.</p>
        )}
      </div>

      {isModalOpen && (
        <DeleteConfirmModal
          onClose={() => setIsModalOpen(false)}
          onConfirm={confirmDelete}
          setIsModalOpen={setIsModalOpen}
        />
      )}
    </div>
  );
};

export default OpenPositions;
